import { render, staticRenderFns } from "./BldStartup.vue?vue&type=template&id=2a23499c&scoped=true&"
import script from "./BldStartup.vue?vue&type=script&lang=js&"
export * from "./BldStartup.vue?vue&type=script&lang=js&"
import style0 from "./BldStartup.vue?vue&type=style&index=0&id=2a23499c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23499c",
  null
  
)

export default component.exports